<template>
  <div>
    <a
      v-for="(ir, index) in $store.getters.irs"
      v-bind:key="index"
      href="#"
      v-on:click="checkSaved(ir.id)"
      class="list-group-item list-group-item-action py-3"
      v-bind:class="{
        active: ir.id === $store.getters.ir.id
      }"
    >
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">#{{ ir.data.ir_number }}</h5>
        <h5 class="mb-1">L{{ ir.data.building_level }}</h5>
        <small>{{ ir.data.start_time | moment("MM/DD/YY, hh:mmA") }}</small>
      </div>
      <h5>{{ ir.data.description }}</h5>
      <div class="d-flex w-100 justify-content-between">
        <small>{{ ir.data.grid_location }}</small>
        <small
          class="text-uppercase font-weight-bold"
          v-bind:class="{
            'text-success': ir.data.status === 'passed',
            'text-warning': ir.data.status === 'not ready',
            'text-danger': ir.data.status === 'failed',
            'text-primary': ir.data.status === 'in progress'
          }"
          >{{ ir.data.status }}</small
        >
      </div>
    </a>
  </div>
</template>

<script>
import bootbox from "bootbox";

export default {
  name: "IRListItems",
  methods: {
    checkSaved: function(id) {
      const useThis = this;
      if (this.$store.getters.irSaved === false) {
        bootbox.confirm({
          message: "You have unsaved changes.",
          buttons: {
            confirm: {
              label: "Save",
              className: "btn-success"
            },
            cancel: {
              label: "Don't Save",
              className: "btn-danger"
            }
          },
          onEscape: false,
          closeButton: false,
          size: "small",
          centerVertical: true,
          callback: function(result) {
            if (result) {
              useThis.$store.dispatch("saveIR").then(function(res) {
                useThis.loadNewIR(id);
              });
            } else {
              useThis.$store.commit("irSaved", true);
              useThis.loadNewIR(id);
            }
          }
        });
      } else {
        this.loadNewIR(id);
      }
    },
    loadNewIR: function(id) {
      this.$store.dispatch("loadIR", id);
    }
  }
};
</script>

<style scoped>
.list-group-item.active {
  background: rgba(0, 123, 255, 0.1);
  border-color: rgba(0, 123, 255, 0.2);
  color: #000;
}

.list-group-item.active small {
  color: rgba(0, 0, 0, 0.5);
}
</style>
